export default class AddressInfoModel {

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.first_name = model.first_name ? model.first_name : '';
        this.last_name = model.last_name ? model.last_name : '';
        this.company_name = model.company_name ? model.company_name : '';
        this.address = model.address ? model.address : '';
        this.city = model.city ? model.city : '';
        this.state = model.state ? model.state : '';
        this.zip = model.zip ? model.zip : '';
        this.country = model.country ? model.country : '';
    }

}
